// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__QCqUu","AuthForm":"Auth_AuthForm__nJCm2","AuthGeneralError":"Auth_AuthGeneralError__fgoJe"};